import { Box } from '@mui/material';
import { getSigners } from 'lib/api/business';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions, {
  CustomButtonProps,
} from 'lib/designSystem/HeaderWithActions';
import Table from 'lib/designSystem/Table';
import { errorHandler } from 'lib/functions/errors';
import { User } from 'lib/types/models';
import AssignSigner from 'pages/BusinessProfile/Contracts/Signers/Components/AssignSigner';
import CreateSigner from 'pages/BusinessProfile/Contracts/Signers/Components/CreateSigner';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'services/redux/store';

const Signers = () => {
  const dispatch = useDispatch();
  const [signers, setSigners] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const user = useSelector((state: RootState) => state.auth.user);
  const [openCreateSigner, setOpenCreateSigner] = useState(false);
  const [openAssignSigner, setOpenAssignSigner] = useState(false);

  const fetchSigners = async () => {
    try {
      setLoading(true);
      const signers = await getSigners(dispatch, user?.businessIdentifier);
      setSigners(signers);
    } catch (error) {
      errorHandler(dispatch, error);
    } finally {
      setLoading(false);
    }
  };

  const tableHeaders = [
    { key: 'identifier', label: 'Rut' },
    { key: 'name', label: 'Nombre' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Teléfono' },
  ];

  const buttons: CustomButtonProps[] = [
    {
      name: 'Asignar firmante',
      color: 'secondary',
      action: () => setOpenAssignSigner(true),
    },
    {
      name: 'Crear firmante',
      color: 'primary',
      action: () => setOpenCreateSigner(true),
    },
  ];

  useEffect(() => {
    void fetchSigners();
  }, []);

  if (loading) return <CenteredCircularProgress />;

  return (
    <>
      <Box mt={2}>
        <HeaderWithActions
          title="Aca podras ver una lista con los firmantes de tu empresa."
          variant="body1"
          buttons={buttons}
          type="subHeader"
        />
        <Table data={signers} dataHeaders={tableHeaders} />
      </Box>
      <CreateSigner
        open={openCreateSigner}
        setOpen={setOpenCreateSigner}
        fetchSigners={fetchSigners}
        businessIdentifier={user?.businessIdentifier}
      />
      <AssignSigner
        open={openAssignSigner}
        setOpen={setOpenAssignSigner}
        fetchSigners={fetchSigners}
      />
    </>
  );
};

export default Signers;
